export enum IntegrationProvider {
  Google = 1,
  Microsoft = 2,
  Apple = 3,
  CourtPortal = 4,
  Imap = 5,
  WFirma = 6,
}
